import { useIsAuth } from 'feature/auth/hooks'
import { FC, Suspense } from 'react'
import { Navigate, Outlet } from 'react-router'
import { isLkmDomain } from './utils'

import { Loading } from './Loading'

// завешенный маршрут (редиректит пользователей с неполной регистрацией)
export const ProtectedRoute: FC = () => {
  const isAuth = useIsAuth()

  if (!isAuth) {
    return <Navigate to={isLkmDomain() ? '/login' : '/'} replace />
  }

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  )
}
